import script from "./QuestionariTemplatesAdmin.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionariTemplatesAdmin.vue?vue&type=script&setup=true&lang=js"

import "./QuestionariTemplatesAdmin.vue?vue&type=style&index=0&id=3db0efc8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3db0efc8"]])

export default __exports__